import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';

const styles = {
    parent: {
        position: 'relative'
    },
    file: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
        zIndex: 10
    },
    button: {
        position: 'relative',
        zIndex: 1
    },
    error:  {
        lineHeight: '2em',
        bottom: 0
    }
};

const hashString = (string) => string.split("").reduce((hash, char) => ((hash << 5) - hash + char.charCodeAt(0) ) & 0xFFFFFFFF);
const generateId = (name, label = '') => `frc-${name.replace(/\[/g, '_').replace(']', '')}-${hashString(JSON.stringify(label))}`;

export const validateMimeType = (type, allowedMimeTypes, strict = false) => {
    if (!type || !allowedMimeTypes || allowedMimeTypes.length < 1) { return !strict; }
    return (allowedMimeTypes.includes(type));
};

class FileUpload extends Component {

    render() {
        const buttonLabel = (this.props.value && this.props.value.name) || this.props.hintText;
        const valid = !this.props.errorText && this.props.value && validateMimeType(this.props.value.type, this.props.allowedMimeTypes);
        const hasError = this.props.showError && !!this.props.errorText;
        return (
            <div style={styles.parent}>
                <div style={styles.parent} className={this.props.required ? 'required' : ''}>
                    <RaisedButton
                        label={buttonLabel}
                        labelPosition="before"
                        secondary={valid}
                        style={styles.button}
                    />
                    <input
                        ref="element"
                        type="file"
                        id={this.props.id || generateId(this.props.name, this.props.label)}
                        onChange={this.changeValue}
                        disabled={this.props.disabled}
                        style={styles.file}
                    />
                </div>
                {(hasError) && <div className="validation-error" style={styles.error}>{this.props.errorText}</div>}
            </div>
        );
    }

    changeValue = ({ target }) => {
        this.props.onChange(this.props.name, target.files[0], target.value);
    }
}

FileUpload.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.object,
    onChange: PropTypes.func,
    allowedMimeTypes: PropTypes.arrayOf(PropTypes.string),
    required: PropTypes.bool,
    hintText: PropTypes.string,
    errorText: PropTypes.string,
    showError: PropTypes.bool
};

FileUpload.defaultProps = {
    hintText: 'Browse',
    onChange: f => f,
    showError: true
};

export default FileUpload;
